<template>
  <v-app :class="showDarkBlueBackground() ? 'dark-bg' : 'white-bg'">
    <v-main>
      <Header :onDarkBackground="showDarkBlueBackground()" />
      <BreadCrumbs />
      <router-view class="router-content"> </router-view>
    </v-main>
    <v-bottom-navigation style="height: 0px">
      <Snackbar
        :color="snackbarColor"
        :text="snackbarText"
        :open="showSnackbar"
        v-on:update:open="showSnackbar = false"
      />
    </v-bottom-navigation>
    <Footer v-if="route.name === 'home'" />
  </v-app>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { eventBus } from '@/plugins/eventBus'
import Snackbar from '@/components/Snackbar.vue'
import Header from '@/components/header/Header.vue'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import { useRoute } from 'vue-router'
import Footer from '@/components/footer/Footer.vue'

const snackbarColor = ref<string>('error')
const snackbarText = ref<string>('')
const showSnackbar = ref<boolean>(false)
const route = useRoute()

const showDarkBlueBackground = () => {
  return route.name === 'home'
}

try {
  eventBus.$on('accessDenied', (error: string) => handleAccessDenied(error))
  eventBus.$on('apiRequestError', (error: string) => handleApiRequestError(error))
  eventBus.$on('apiResponseError', (error: string) => handleApiResponseError(error))
  eventBus.$on('authError', (error: string) => handleAuthError(error))
  eventBus.$on('showSuccess', (success: string) => showSuccess(success))
  eventBus.$on('showError', (error: string) => showError(error))
} catch (e) {
  showError('Failed to initialise app')
}

function handleAccessDenied(error: string): void {
  showError(
    'Access denied. Required roles to perform this operation are not present in your session'
  )
}

function handleApiResponseError(error: string): void {
  showError('Error during API call')
}

function handleApiRequestError(error: string): void {
  showError('Error during API call')
}

function handleAuthError(error: string): void {
  showError('Authentication error during API call')
}
function showError(error: string) {
  snackbarColor.value = 'error'
  openSnackbar(error)
}

function showSuccess(success: string) {
  snackbarColor.value = 'success'
  openSnackbar(success)
}

function showWarning(warning: string) {
  snackbarColor.value = 'warning'
  openSnackbar(warning)
}

function openSnackbar(text: string) {
  if (showSnackbar.value) {
    showSnackbar.value = false
  }
  showSnackbar.value = true
  snackbarText.value = text
}
</script>

<style lang="scss">
.router-content {
  margin-top: 0em;
  padding: 0 1em;
}

@media only screen and (min-width: 940px) {
  .router-content {
    margin: 0 5em 5em 5em;
  }
}

.dark-bg {
  background-color: #1f4f59 !important;
}

.white-bg {
  background-color: #ffffff !important;
}
</style>
